import axiosClient from "./axios";

export const fetchBidItems = async (orderId) => {
  const response = await axiosClient.get(`lite/v2/api/admin/bids/items/${orderId}`);
  return response?.data?.data || {};
};

export const acceptBid = async ({ bidId, ordertype }) => {
  return axiosClient.post(
    "lite/v2/api/admin/bids/accept",
    {
      bid_id: bidId,
      ordertype,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const requestBidPriceUpdate = async (bidId) => {
  return axiosClient.post(`lite/v2/api/admin/bids/backtovendor/${bidId}`);
};
